<div class="border border-gray-200 rounded-lg p-3 flex flex-col gap-3" data-cy="medical-veterinary-card">
  <div class="flex items-center justify-between gap-2">
    <span class="font-semibold text-sm flex items-center gap-2">
      <i class="pi pi-home text-[var(--p-primary-600)]"></i>
      {{ 'animalMedical.veterinary.headline' | transloco }}
    </span>
    <p-button
      size="small"
      [text]="true"
      icon="pi pi-pen-to-square"
      [ariaLabel]="'animalMedical.veterinary.edit' | transloco"
      [pTooltip]="'animalMedical.veterinary.edit' | transloco"
      tooltipPosition="top"
      (onClick)="openDialog()"
    />
  </div>

  @if (primary) {
    <div class="flex flex-col gap-1 text-sm">
      <span class="font-semibold">{{ name(primary.contact) }}</span>
      @if (personName(primary.contact)) {
        <span>{{ personName(primary.contact) }}</span>
      }
      @if (primary.link.label) {
        <span class="text-xs text-gray-500">{{ primary.link.label }}</span>
      }
      @if (phone(primary.contact); as phone) {
        <a class="flex items-center gap-2 hover:underline" [href]="'tel:' + phone">
          <i class="pi pi-phone text-xs text-gray-500"></i>{{ phone }}
        </a>
      }
      @if (primary.contact?.email) {
        <a class="flex items-center gap-2 hover:underline break-all" [href]="'mailto:' + primary.contact?.email">
          <i class="pi pi-envelope text-xs text-gray-500"></i>{{ primary.contact?.email }}
        </a>
      }
      @if (address(primary.contact)) {
        <span class="flex items-start gap-2">
          <i class="pi pi-map-marker text-xs text-gray-500 mt-1"></i>{{ address(primary.contact) }}
        </span>
      }
    </div>
  } @else {
    <div class="flex flex-col gap-2 text-sm text-gray-500">
      <span>{{ 'animalMedical.veterinary.empty' | transloco }}</span>
      <p-button
        size="small"
        [outlined]="true"
        icon="pi pi-plus"
        [label]="'animalMedical.veterinary.add' | transloco"
        (onClick)="openDialog()"
      />
    </div>
  }

  @if (others.length) {
    <div class="flex flex-col gap-1 border-t border-gray-200 pt-2 text-sm">
      <span class="text-xs uppercase tracking-wide text-gray-500">{{ 'animalMedical.veterinary.others' | transloco }}</span>
      @for (entry of others; track entry.link.id) {
        <div class="flex items-center justify-between gap-2">
          <span class="truncate">{{ name(entry.contact) }}</span>
          @if (entry.link.label) {
            <span class="text-xs text-gray-500 whitespace-nowrap">{{ entry.link.label }}</span>
          }
        </div>
      }
    </div>
  }
</div>

<p-dialog
  [(visible)]="dialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '48rem', maxWidth: '95vw' }"
  appendTo="body"
>
  <ng-template pTemplate="header">
    <h3>{{ 'animalMedical.veterinary.dialogHeader' | transloco }}</h3>
  </ng-template>

  <div class="flex flex-col gap-3">
    @if (!rows.length) {
      <p-message severity="info">{{ 'animalMedical.veterinary.empty' | transloco }}</p-message>
    } @else {
      <div class="grid grid-cols-[minmax(0,1fr)_12rem_auto_auto] gap-x-3 gap-y-2 items-center text-sm">
        <span class="text-xs text-gray-500">{{ 'animalMedical.veterinary.columns.veterinarian' | transloco }}</span>
        <span class="text-xs text-gray-500">{{ 'animalMedical.veterinary.columns.label' | transloco }}</span>
        <span class="text-xs text-gray-500">{{ 'animalMedical.veterinary.columns.primary' | transloco }}</span>
        <span></span>
        @for (row of rows; track row.contactId; let i = $index) {
          <span class="font-medium truncate">{{ rowName(row) }}</span>
          <input
            pInputText
            type="text"
            class="p-inputtext-sm w-full"
            [(ngModel)]="row.label"
            [placeholder]="'animalMedical.veterinary.labelPlaceholder' | transloco"
          />
          <p-radiobutton
            name="primaryVeterinarian"
            [value]="i"
            [ngModel]="row.isPrimary ? i : null"
            (ngModelChange)="setPrimary(i)"
            [ariaLabel]="'animalMedical.veterinary.columns.primary' | transloco"
          />
          <p-button
            size="small"
            [text]="true"
            severity="danger"
            icon="pi pi-trash"
            [ariaLabel]="'animalMedical.veterinary.remove' | transloco"
            (onClick)="removeRow(i)"
          />
        }
      </div>
    }

    <div class="flex flex-col gap-1">
      <label class="text-xs text-gray-500" for="addVeterinarian">{{ 'animalMedical.veterinary.add' | transloco }}</label>
      <app-veterinarian-select
        inputId="addVeterinarian"
        [excludeIds]="excludedContactIds"
        [ngModel]="addContactId"
        (ngModelChange)="onAddContact($event)"
      />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-times"
      [text]="true"
      [label]="'modal.cancel' | transloco"
      (onClick)="closeDialog()"
    />
    <p-button
      icon="pi pi-save"
      [label]="'modal.save' | transloco"
      [loading]="saving"
      [disabled]="saving"
      (onClick)="save()"
    />
  </ng-template>
</p-dialog>
